<div class="gts" data-testid="github-token-section">
  <div class="gts__head">
    <span class="gts__tile" aria-hidden="true">
      <i class="fa-brands fa-github"></i>
    </span>

    <div class="gts__host-col">
      <div class="gts__host-line">
        <span class="gts__badge">{{ 'githubToken.provider' | translate }}</span>
        <code class="gts__host">{{ 'githubToken.host' | translate }}</code>
      </div>
      <div class="gts__usage">{{ 'githubToken.usage' | translate }}</div>
    </div>

    <span
      class="gts__pill"
      [class.gts__pill--set]="tokenSet()"
      [class.gts__pill--missing]="!tokenSet()"
      role="status"
      aria-live="polite"
      data-testid="github-token-state"
    >
      <span class="gts__dot"></span>
      {{ (tokenSet() ? 'githubToken.status.set' : 'githubToken.status.missing') | translate }}
    </span>
  </div>

  <div class="gts__body">
    <div class="gts__form">
      <input
        class="gts__input"
        type="password"
        autocomplete="off"
        data-testid="github-token-input"
        [attr.aria-label]="'githubToken.expand.inputLabel' | translate"
        [attr.placeholder]="
          (tokenSet() ? 'githubToken.expand.placeholderReplace' : 'githubToken.expand.placeholder') | translate
        "
        [value]="draft()"
        [disabled]="busy()"
        (input)="onDraftInput($event)"
        (keyup.enter)="save()"
      />
      <button
        type="button"
        class="gts__save"
        data-testid="github-token-save"
        [disabled]="!draft().trim() || busy()"
        (click)="save()"
      >
        {{ (tokenSet() ? 'githubToken.action.replace' : 'githubToken.action.save') | translate }}
      </button>
      @if (tokenSet()) {
        <button
          type="button"
          class="gts__delete"
          data-testid="github-token-delete"
          [disabled]="busy()"
          (click)="remove()"
        >
          {{ 'githubToken.action.delete' | translate }}
        </button>
      }
    </div>

    <p class="gts__help">{{ 'githubToken.help' | translate }}</p>
  </div>
</div>
